import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=35fbae10"
import script from "./Duration.vue?vue&type=script&lang=js"
export * from "./Duration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dates: require('/vercel/path0/components/partials/Dates.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default})
